import Flex from 'components/ui/Flex';
import Loader from 'components/ui/Loader';
import useAppDispatch from 'hooks/useAppDispatch';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Row } from 'reactstrap';
import { toast } from 'react-toastify';
import services from 'services';
import { confirmB2BCheckout, confirmCheckout } from 'store/reducers/cartSlice';
import { takePaymentReturnData } from './paymentReturnStorage';

// Landing page for Stripe's returnUrl after a redirect-based payment method (e.g. Klarna) completes.
// The actual payment validation is handled by the checkout.session webhook.
const PaymentReturn = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const placedRef = useRef(false);

    useEffect(() => {
        if (placedRef.current) return;
        placedRef.current = true;

        const sessionId = new URLSearchParams(window.location.search).get('session_id');
        const data = takePaymentReturnData();

        if (!sessionId || !data) {
            toast.error(t('payment_failed'));
            navigate('/cart', { replace: true });
            return;
        }

        (async () => {
            try {
                const session = await services.stripe.getCheckoutSessionStatus(sessionId);
                if (session?.status !== 'complete') {
                    toast.error(t('payment_failed'));
                    navigate('/cart', { replace: true });
                    return;
                }

                const { shippingOptionId } = data;
                if (data.isB2B) {
                    await dispatch(
                        confirmB2BCheckout({ b2bCheckout: { delivery: data.delivery }, shippingOptionId }),
                    ).unwrap();
                } else {
                    await dispatch(confirmCheckout({ standardCheckout: data.standardCheckout, shippingOptionId })).unwrap();
                }

                navigate('/cart', { replace: true, state: { view: 'confirm' } });
            } catch {
                toast.error(t('payment_failed'));
                navigate('/cart', { replace: true });
            }
        })();
    }, [dispatch, navigate, t]);

    return (
        <Row className="my-5 py-5 justify-content-center align-items-center">
            <Flex className="justify-content-center align-items-center" column>
                <Loader label={t('loading')} loading={true} />
            </Flex>
        </Row>
    );
};

export default PaymentReturn;
